import { saleStatusHistory } from '@/config'

const detail = {
  line1: [
    {
      name: 'customerName',
      text: 'sale.sale_customer-name',
      component: 'MultipleSelectCustomerName'
    },
    {
      name: 'refundDate',
      text: 'refund.refund_refund-date',
      component: 'FromToDatePicker'
    },
    {
      name: 'storage',
      text: 'refund.refund_refund-warehousing-warehouse',
      component: 'SelectStorageName',
      hasDefault: false,
      cols: 5
    },
    {
      name: 'status',
      text: 'common.common_status',
      component: 'SelectStatusRefund',
      cols: 4
    }
  ],
  line2: [
    {
      name: 'saleInfo',
      text: 'sale.sale_sale-info',
      component: 'SearchRefundInfo'
    },
    {
      name: 'productInfo',
      text: 'sale.sale_product-info',
      component: 'SearchProductNoAndProductCategory'
    }
  ]
}

export default { detail }
